import { useState, useRef } from 'react';

export default function useThrottledValue({ timeout }) {
  const [value, setValue] = useState(false);
  const valueTimeout = useRef(null);

  const updateValue = value => {
    if (value) {
      valueTimeout.current = setTimeout(() => {
        setValue(value);
      }, timeout ?? 100);
    } else {
      if (valueTimeout.current) {
        clearTimeout(valueTimeout.current);
        valueTimeout.current = null;
      }
      setValue(value);
    }
  };

  return { updateValue, value };
}
